import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { ImgInvModel } from '../models/ImgInvModel';
import { ImageTypeModel } from '../models/ImgInvModel';
import { URLsConfig } from '../URLsConfig';

@Injectable()
export class ImgInvService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }

  public getImgInvAll(imginvcode: string , compcode: string) {

      let params = new HttpParams();
        params = params.append("ImgInvCode", imginvcode);
        params = params.append("CompCode", compcode);

        const options = {
          params: params
      };
      return this.http.get<ImgInvModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ImgInv/GetImgInv',options);
    }


    public AddImgInv(imgInv: ImgInvModel) {
      return this.http.post<ImgInvModel>(this.urlsconfig.WebAPIURL_Test + 'api/ImgInv/AddImgInv', imgInv);
    }

    public delImgInv_Line(imginvcode: string ,imginvdate: string, imginvtype:string ,compcode: string) {

    let params = new HttpParams();
    params = params.append("ImgInvCode", imginvcode);
    params = params.append("ImgInvDate", imginvdate);
    params = params.append("ImgInvType", imginvtype);
    params = params.append("CompCode", compcode);


      const options = {
        params: params
    };
    return this.http.delete<ImgInvModel>(this.urlsconfig.WebAPIURL_Test + 'api/ImgInv/DeleteImgInv',options);
    }

    public getImageTypeLookupTop() {
      let params = new HttpParams();
      const options = {
          params: params
      };
      return this.http.get<ImageTypeModel[]>(this.urlsconfig.WebAPIURL_Test + 'api/ImgInv/ImageTypeLookupTop', options);
  }
  }
